export default (items) => ({
  active: 1,
  moving: false,
  left: false,
  touchStartX: 0,

  swipeDirection() {
    const touchendX = this.$event.changedTouches[0].screenX;

    if (touchendX < this.touchStartX) {
      this.next();
    } else if (touchendX > this.touchStartX) {
      this.prev();
    }
  },

  next() {
    this.left = true;
    this.moving = true;
    this.active = (this.active + 1) % items;
    setTimeout(() => {
      this.moving = false;
    }, 1100);
  },

  prev() {
    this.left = false;
    this.moving = true;
    this.active = (items + this.active - 1) % items;
    setTimeout(() => {
      this.moving = false;
    }, 1100);
  },

  getPos(index) {
    if (
      index == (items + this.active - 1) % items ||
      index == (items + this.active - 2) % items
    ) {
      let ret = 'offer-card--left';
      if (
        this.moving &&
        !this.left &&
        index == (items + this.active - 2) % items
      ) {
        ret += ' offer-card--moving';
      }
      return ret;
    } else if (index !== this.active) {
      let ret = 'offer-card--right';
      if (this.moving && this.$el.classList.contains('offer-card--left')) {
        ret += ' offer-card--moving';
      }
      return ret;
    }
    return '';
  },

  getIndex(index) {
    return ((index - this.active + items) % items) - 1;
  },

  init() {},
});
